import React from 'react';
import { X } from 'lucide-react';
import IntegratedBookingSection from './IntegratedBookingSection';

export default function InstantBookingModal({ isOpen, onClose, preSelectedTopic = null, initialLawyerId = null }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6 overflow-y-auto">
      {/* Dark Backdrop */}
      <div 
        className="fixed inset-0 bg-black/85 backdrop-blur-md transition-opacity animate-in fade-in duration-200"
        onClick={onClose}
      />

      {/* Modal Dialog */}
      <div className="relative w-full max-w-4xl max-h-[92vh] flex flex-col bg-[#070c16] border border-[#c59b27]/50 rounded-2xl shadow-2xl shadow-black/95 z-10 my-auto overflow-hidden animate-in zoom-in-95 duration-200">
        
        {/* Top Accent Strip */}
        <div className="h-1.5 w-full bg-gradient-to-r from-[#b38038] via-[#c59b27] to-[#d4af37] shrink-0" />

        {/* Close Button Top Right */}
        <button
          onClick={onClose}
          className="absolute top-3.5 right-3.5 z-30 w-8 h-8 rounded-full bg-[#131d2e] hover:bg-[#1c2c46] border border-[#c59b27]/50 flex items-center justify-center text-slate-300 hover:text-white transition-all cursor-pointer shadow-md"
          title="Yopish"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Integrated Booking Form */}
        <div className="p-2 sm:p-4 overflow-y-auto">
          <IntegratedBookingSection 
            preSelectedTopic={preSelectedTopic} 
            initialLawyerId={initialLawyerId}
            compact={true}
            onBack={onClose}
            onSuccess={() => {
              // keep open so user sees confirmation code
            }}
          />
        </div>
      </div>
    </div>
  );
}
